import styled from '@emotion/styled'
import React, { useEffect, useState } from 'react'
import { theme } from '../../../theme'

import { Flex, FlexProps } from '@chakra-ui/react'

const ContenaireRight = styled(Flex)`
  color: ${theme.colors.red[600]};
  font-size: 0.8rem;
  font-weight: 900;
  position: absolute;
  top: ${({ top }) => (top ? top : null)};
  background-color: ${theme.colors.red[50]};
  border: 2px solid ${theme.colors.red[100]};
  border-radius: 10px;
  left: ${({ right }) => (right ? right : null)};
  width: max-content;
  max-width: 10rem;
  padding: 1.5rem;
  &::after {
    content: '';
    background-color: ${theme.colors.red[50]};
    border-bottom: 2px solid ${theme.colors.red[100]};
    border-left: 2px solid ${theme.colors.red[100]};
    position: absolute;
    top: 50%;
    left: 0;
    width: 0.5rem;
    height: 0.5rem;
    transform: translate(-50%, -50%) rotate(45deg);
  }
`
const ContenaireTop = styled(Flex)`
  color: ${theme.colors.red[600]};
  font-size: 0.7rem;
  font-weight: 700;
  position: absolute;
  top: -30%;
  right: 0;
  background-color: ${theme.colors.red[50]};
  border: 2px solid ${theme.colors.red[100]};
  border-radius: 10px;
  width: max-content;
  max-width: 20rem;
  padding: 0.5rem;
  &::after {
    content: '';
    background-color: ${theme.colors.red[50]};
    border-bottom: 2px solid ${theme.colors.red[100]};
    border-right: 2px solid ${theme.colors.red[100]};
    position: absolute;
    right: 2rem;
    bottom: 0;
    width: 0.5rem;
    height: 0.5rem;
    transform: translate(50%, 50%) rotate(45deg);
  }
`
interface Props extends FlexProps {
  boxPosition?: string
}
const StateFormIndicator: React.FC<Props> = ({ children, boxPosition, ...rest }) => {
  const [show, setShow] = useState(true)

  // On componentDidMount set the timer
  useEffect(() => {
    const timeId = setTimeout(() => {
      // After 3 seconds set the show value to false
      setShow(false)
    }, 300000)

    return () => {
      clearTimeout(timeId)
    }
  }, [])

  // If show is false the component will return null and stop here
  if (!show) {
    return null
  }

  return boxPosition === 'top' ? (
    <ContenaireTop zIndex={60} {...rest}>
      {children}
    </ContenaireTop>
  ) : (
    <ContenaireRight top={0} zIndex={60} {...rest}>
      {children}
    </ContenaireRight>
  )
}

StateFormIndicator.defaultProps = {
  right: '102%',
  boxPosition: 'left'
}
export default StateFormIndicator
